import { AxiosResponse, CancelToken } from "axios";
import http from "../../../../shared/http";
import {
  ReservationReserveRequestDto,
  ReservationReserveResponseDto,
} from "./dtos";

export const reserveReservation = async (
  data: ReservationReserveRequestDto,
  cancelToken: CancelToken
): Promise<AxiosResponse<ReservationReserveResponseDto>> => {
  return await http.post<ReservationReserveResponseDto>(`/reservation`, data, {
    cancelToken,
  });
};
